<!--
 * www.cloudscope.cn
 * Copyright (c) 2019. All Rights Reserved.
-->
<!--
 * @Author: liuchang
 * @Description: 添加操作管理页面
 -->
<template>
    <!-- 添加操作 Dialog: Begin -->
    <el-dialog
        :title="addTitle"
        :visible.sync="dialogVisible"
        custom-class="mod-dialog"
        append-to-body
        @close="close"
        width="500px"
    >
        <div class="main-contain">
            <el-form
                ref="operation"
                :model="operation"
                class="mod-dialog-form"
                label-width="55px"
                :rules="rules"
            >
                <el-form-item label="编码" prop="code">
                    <el-input v-model="operation.code" placeholder="输入名称"></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="name">
                    <el-input v-model="operation.name" placeholder="输入名称"></el-input>
                </el-form-item>
                <el-form-item label="链接" prop="url">
                    <el-input v-model="operation.url" placeholder="输入名称"></el-input>
                </el-form-item>
                <el-form-item label="菜单" prop="menuId">
                    <el-select v-model="operation.menuId" placeholder="请选择" style="width:100%;">
                        <el-option
                            v-for="item in operationList"
                            :value="item.id"
                            :key="item.id"
                            :label="item.name"
                        >{{ item.name }}</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" prop="status" v-show="isAdd">
                    <el-select v-model="operation.status" placeholder="请选择" style="width:100%;">
                        <el-option label="启用" value="1"></el-option>
                        <el-option label="禁用" value="0"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" style="width:72px" type="info" @click="close('Cancel')">取消</el-button>
            <el-button
                size="mini"
                style="width:72px"
                type="primary"
                @click="addOperation('operation')"
                v-show="isAdd"
            >添加</el-button>
            <el-button
                size="mini"
                style="width:72px"
                type="primary"
                @click="updateOperation('operation')"
                v-show="isUpdate"
            >修改</el-button>
        </span>
    </el-dialog>
    <!-- 添加用户 Dialog: Begin -->
</template>

<script>
export default {
    components: {},
    props: ['addTitle'],
    data () {
        return {
            operation: {
                icon: '',
                name: '',
                orderd: 1,
                parentid: '',
                status: '',
                url: ''
            },
            disableUrl: true,
            dialogVisible: false,
            radio: '1',
            iconRadio: '',
            exist: 'have',
            operationList: [],
            isAdd: true,
            isUpdate: false,
            rules: {
                name: [
                    {
                        required: true,
                        message: '名称不能为空.',
                        trigger: 'blur'
                    },
                    { type: 'string', max: 16, message: '名称最大16个字符.' }
                ],
                icon: [
                    {
                        required: true,
                        message: '图标不能为空.',
                        trigger: 'change'
                    }
                ],
                url: [
                    {
                        type: 'string',
                        max: 32,
                        message: '链接最大32个字符.',
                        trigger: 'blur'
                    }
                ],
                orderd: [
                    {
                        required: true,
                        message: '序号不能为空.',
                        trigger: 'change'
                    }
                ],
                code: [
                    {
                        required: true,
                        message: '编码不能为空.',
                        trigger: 'change'
                    }
                ],
                link: [
                    {
                        required: true,
                        message: '链接不能为空.',
                        trigger: 'change'
                    }
                ],
                parentid: [
                    {
                        required: true,
                        message: '菜单不能为空.',
                        trigger: 'change'
                    }
                ],
                status: [
                    {
                        required: true,
                        message: '状态不能为空.',
                        trigger: 'change'
                    }
                ]
            }
        };
    },
    mounted () {},
    watch: {
        // 监听有无子菜单
        exist (value, oldValue) {
            if (value === 'have') {
                this.disableUrl = true;
                this.operation.url = '';
            } else {
                this.disableUrl = false;
            }
        }
    },
    methods: {
        /**
         * @author: liuc
         * @description:关闭弹窗
         * @param {operateType} 数据参数
         */
        close (operateType) {
            this.dialogVisible = false;
            this.operation = {
                icon: '',
                name: '',
                orderd: 1,
                parentid: '',
                status: '',
                url: ''
            };
            this.exist = 'have';
            this.$refs.operation.resetFields(); // 移除校验结果
            this.$emit('closeAddModal', operateType); // 刷新表格
        },
        /**
         * @author: liuc
         * @description:打开弹窗，判断是“新增”还是“编辑”
         * @param {type} 弹窗类型
         * @param {id} 数据id
         */
        open: async function (type, id) {
            // 编辑弹窗
            if (type == 1) {
                this.queryOperationById(id);
                this.isAdd = false;
                this.isUpdate = true;
            } else {
                // 新增弹窗
                this.isAdd = true;
                this.isUpdate = false;
            }
            this.dialogVisible = true;
        },
        /**
         * @author: liuc
         * @description: 获取菜单列表
         * @param {}
         */
        async queryOperationList () {
            let response = await this.$api.MenuManagement.getAll();
            this.operationList = response.data;
        },
        /**
         * @author: liuc
         * @description:根据id查询操作信息
         * @param {id} 操作id
         */
        async queryOperationById (id) {
            let response = await this.$api.OperationManagement.queryOperationById(
                {
                    id: id
                }
            );
            this.operation = response.data;
            if (this.isNotNull(this.operation.url)) {
                this.exist = 'not';
            } else {
                this.exist = 'have';
            }
        },
        /**
         * @author: liuc
         * @description:新增菜单
         * @param {formName} 表单名称
         */
        addOperation (formName) {
            this.$refs[formName].validate(async (valid, notValid) => {
                if (valid) {
                    let result = await this.verifyName(this.operation.code);
                    if (result) {
                        let response = await this.$api.OperationManagement.addOperation(
                            this.operation
                        );
                        if (response.code == 200) {
                            this.$message.success('保存成功');
                            this.close('success');
                        }
                    }
                } else {
                    this.$message.error('验证失败');
                    return false;
                }
            });
        },
        /**
         * @author: liuc
         * @description:编辑菜单
         * @param {formName} 表单名称
         */
        updateOperation (formName) {
            this.$refs[formName].validate(async (valid, notValid) => {
                if (valid) {
                    let result = await this.verifyName(this.operation.code);
                    if (result) {
                        let response = await this.$api.OperationManagement.updateOperationById(
                            this.operation
                        );
                        if (response.code == 200) {
                            this.$message.success('修改成功');
                            this.close('success');
                        }
                    }
                } else {
                    this.$message.error('验证失败');
                    return false;
                }
            });
        },
        /**
         * @author: liuc
         * @description: 查询name是否重复
         * @param {name} 信息内容
         */
        async verifyName (name) {
            if (this.isNotNull(name)) {
                let nameData = {
                    code: name,
                    id: this.operation.id == undefined ? '' : this.operation.id
                };
                let response = await this.$api.OperationManagement.operationVerifyName(
                    nameData
                );
                if (response.code == 200) {
                    return true;
                } else {
                    this.$message.error('编码重复，请检查。');
                }
            }
            return false;
        },
        /**
         * @author: liuc
         * @description: 判断传入的值是否为空
         * @param {target} 传入内容
         */
        isNotNull (target) {
            if (target) {
                return true;
            } else {
                return false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ./src/components/OperationalManagement/Add.vue